import {
  baseQueryParamMapping,
  defaultReportingPeriod,
} from '@/components/core/analytics/queryParamMapping';
import { getMetrics, METRICS } from '@/models/metrics.enum';
import { PLATFORM_CONNECTION } from '@/models/platform/platform-connection.enum';

export const useYourPosts = () => {
  const metrics = getMetrics('yourPosts');

  return {
    title: 'Snapchat Posts',
    channelFilterKey: 'snapchat',
    filters: {
      brandMediaTypes: [
        'SNAPCHAT_OWNED_SPOTLIGHT',
        'SNAPCHAT_OWNED_STORY',
        'SNAPCHAT_OWNED_SAVED_STORY',
      ],
      default: {
        contentTags: [],
        contentTagMatchType: 'ANY',
        postType: [],
        reportingPeriod: defaultReportingPeriod,
        sort: {
          sortOrder: 'DESC',
          selected: { value: 'DATE', label: 'Recently Published' },
        },
      },
      options: {
        postType: [
          { label: 'Saved Story', value: 'SAVED_STORY' },
          { label: 'Spotlight', value: 'SPOTLIGHT' },
          { label: 'Story', value: 'STORY' },
        ],
      },
      queryParamMapping: {
        ...baseQueryParamMapping,
        postType: { queryParamName: 'postType', type: 'array', elementType: 'string' },
      },
      requestParamsMapping: {
        postType: 'assetTypes',
      },
      labelOverrides: {
        postType: { singular: 'Post Type', plural: 'Post Types' },
      },
      scope: 'snapchatYourPosts',
      sortDetails: {
        options: [
          { label: 'Recently Published', value: 'DATE' },
          ...metrics.all([
            METRICS.SNAPCHAT.AVG_VIEW_TIME,
            METRICS.SNAPCHAT.ENGAGEMENTS,
            METRICS.SNAPCHAT.ENGAGEMENT_RATE,
            METRICS.SNAPCHAT.FAVORITES,
            METRICS.SNAPCHAT.SCREENSHOTS,
            METRICS.SNAPCHAT.SHARES,
            METRICS.SNAPCHAT.VIEW_TIME,
            METRICS.SNAPCHAT.VIEWERS,
            METRICS.SNAPCHAT.VIEWS,
          ]),
        ],
        postTypeCompatibleSortValues: [
          'DATE',
          'SNAPCHAT_AVG_VIEW_TIME_SECONDS',
          'SNAPCHAT_FAVORITES',
          'SNAPCHAT_SCREENSHOTS',
          'SNAPCHAT_VIEW_TIME_SECONDS',
          'SNAPCHAT_VIEWERS',
          'SNAPCHAT_VIEWS',
          'SNAPCHAT_ENGAGEMENTS',
          'SNAPCHAT_ENGAGEMENT_RATE',
        ],
        default: {
          sortOrder: 'DESC',
          selected: { value: 'DATE', label: 'Recently Published' },
        },
      },
    },
    displayMetrics: metrics.all([
      METRICS.SNAPCHAT.VIEWS,
      METRICS.SNAPCHAT.VIEWERS,
      METRICS.SNAPCHAT.AVG_VIEW_TIME,
      METRICS.SNAPCHAT.ENGAGEMENTS,
    ]),
    metricLabels: metrics.all(Object.values(METRICS.SNAPCHAT)),
    download: {
      pdf: {
        fileName: 'yourSnapchatPostsPDF',
        type: 'snapchatYourPosts',
        label: 'Your Snapchat Posts PDF',
        pendingKey: 'snapchatYourPostsReportPending',
      },
      csv: {
        fileName: 'yourSnapchatPostsCSV',
        type: 'snapchatYourPosts',
        label: 'Your Snapchat Posts CSV',
        pendingKey: 'snapchatYourPostsCSVPending',
      },
    },
    platformConnection: PLATFORM_CONNECTION.SNAPCHAT,
  };
};
